"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayName = getDisplayName;
exports.wrapDisplayName = wrapDisplayName;
function getDisplayName(component) {
  return component.constructor.displayName || component.constructor.name;
}

function wrapDisplayName(component, prefix) {
  return prefix + "(" + getDisplayName(component) + ")";
}